import React from 'react';
import ExceededQuantityWarning from '../../components/below-belt/exceeded-quantity-warning';
import AddOns from '../../components/below-belt/add-ons';
import InstantCheckout from './instant-checkout';
import DomAdjuster from '../../shims/dom-adjuster';
import QuantityInput from '../../shims/quantity-input';
import "./atc-button.scss"
import "./quantity.scss"

let domAdjusted = false;

function AddToCart({
  fulfillmentDetails={},
  pickupDetails={},
  shippingDetails={},
  expressDetails={},
  selectedOption="PICKUP",
  itemId="",
  handleToggle,
  needMoreShown
}) {

  let buttonId = "";
  if(selectedOption==="PICKUP"){
    buttonId = "atc_pickItUp";
  }else if(selectedOption==="STH"){
    buttonId = "atc_shipIt";
  }
  let buttonClass = "";
  if(selectedOption==="EXPRESS"){
    buttonClass = "express_delivery_CTA";
  }
  const atcButtonDisabled = QuantityInput.exceedsAvailableQuantity(selectedOption, fulfillmentDetails, pickupDetails);

  const showAtcButton = () => {
    const allTilesDisabled = (!pickupDetails.enabled && !shippingDetails.enabled && !expressDetails.enabled);
    return (!fulfillmentDetails.showNotifyBox && !allTilesDisabled);
  };

  const showPayPal = () => {
    return (fulfillmentDetails.emptyCart
      && fulfillmentDetails.isPayPalAvailable
      && fulfillmentDetails.payPalPaymentOptionEnabled
      && (selectedOption
      && !atcButtonDisabled)
      && selectedOption !== 'EXPRESS'
      && !fulfillmentDetails.isSubscriptionEligible);
  };

  const getFulfillmentClass = () => {
    if(selectedOption==="STH"){
      return "paypal_ship_to_home";
    }
    else if(selectedOption==="EXPRESS"){
      return "paypal_buy_online_deliver_from_store";
    }
    else if(fulfillmentDetails.pickupType && fulfillmentDetails.pickupType==="BOSS")
      return "paypal_ship_to_store";
    else {
      return "paypal_pick_up_in_store";
    }

  }

  return fulfillmentDetails.doHideForNotifyMe
        // && showAtcButton()
        && !(fulfillmentDetails.isLiveGood
        && (fulfillmentDetails.availabilityType === "Browse Only")
        && !fulfillmentDetails.bopisEligible)
        && (
            <div className="atc-outer-wrapper" style={{display: showAtcButton()?"inline":"none"}}>
            {atcButtonDisabled && (
              <ExceededQuantityWarning
                ffm={selectedOption}
                fulfillmentDetails={fulfillmentDetails}
              />
            )}
              <AddOns
                fulfillmentDetails={fulfillmentDetails}
                selectedOption={selectedOption}
                shippingDetails={shippingDetails}
              />
              { fulfillmentDetails.minimumOrderQuantity &&
              <div className="minimum-message-container">
                <span className="minimum-message-content">
                  <span className="alert-inline--warning"/>
                  <span className="minimum-message">
                    {`We can only ship quantities of ${fulfillmentDetails.minimumOrderQuantity} or more`}
                  </span>
                </span>
              </div>}
              <div
                className="buybelt atc-area"
                style={{display: fulfillmentDetails.proInstallSelected?'none':'flex'}}
              >
          			<div className="atc-button">
                	<div className="atc-button__inner-wrapper">
                    <button id={buttonId}
                  		data-target-atc="ATC"
                  		data-product-id={itemId}
                      disabled={!selectedOption || atcButtonDisabled}
                  		className={
                        "bttn bttn--atc " +
                        buttonClass +
                        ((selectedOption && !atcButtonDisabled)?"":" disabled")}
                    >
                        <span className="bttn__content" onClick={needMoreShown ? handleToggle : undefined}>Add to Cart</span>

                    </button>
                	</div>
                  <div className="instant-checkout-paypal">
                    <InstantCheckout
                        fulfillmentDetails={fulfillmentDetails}
                        selectedOption={selectedOption}
                        shippingDetails={shippingDetails}
                    />
                    {showPayPal() && (
                      <div className="paypal_checkout_btn_area">
                        <div className="or-divider">–– or ––</div>
                        <div className={"buybelt__sub-buybelt__paypal pseudo-button " + getFulfillmentClass()}>
                          <a id="paypal_checkout_btn" data-target-atc="Paypal" className="scrollTouch paypal u__center" href="#"><span className="blurb">Buy now with</span><span className="pip-icons paypal">Paypal</span></a>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
        );

}

export default AddToCart;
